<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Nombre de dossiers en anomalie par collaborateur</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="data" :options="options">
          <div slot="collaborateur_controlleur" slot-scope="props">{{ props.row.nom }} {{ props.row.prenom }} </div>
          <div slot="collaborateur_affecte" slot-scope="props" v-html="!isEmpty(props.row.nom_affecte) ? props.row.nom_affecte +' '+ props.row.prenom_affecte : 'n.d'"></div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button type="button" @click="returnToDetailPage()" class="pull-left ml-1 mr-1 mt-1" size="md" variant="primary">
          Retour campagne
        </b-button>
      </div>
    </b-card>

  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";
  import {isEmpty} from "@/utils/fileHelper";
  import moment from 'moment';

  export default {
    name: "RapportCollaborateur",
    data() {
      return {
        id: null,
        columns: ['collaborateur_controlleur','collaborateur_affecte', 'total'],
        data: [],
        options: {
          headings: {
            'collaborateur_controlleur': 'Collaborateur contrôleur',
            'collaborateur_affecte': 'Collaborateur affecté',
            'total': 'Nb dossier KO',
          },
          filterable: false,
          perPage: 10,
          perPageValues: [10, 25, 50],
          orderBy: {column: 'id', ascending: false}
        },
        isEmpty,
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.id = this.$route.params.id;
      this.getRapportCollaborateur();
    },
    methods: {
      getRapportCollaborateur() {
        this.$store.commit('IS_LOADING', true);
         this.$axios
         .get("/espaceQualite/campagnes/rapport-collaborateur/" + this.id)
         .then(response => {
           this.data = response.data.data;
         })
         .catch((error) => {
            console.log('error : ', error);
         })
         .finally(() => this.$store.commit('IS_LOADING', false));
      },
      returnToDetailPage() {
        this.$router.push({path: '/espace-qualite/campagnes/detail/' + this.id});
      }
    }
  }
</script>
